import {
  activityBaseApi,
  ActivityTags,
} from "activity/redux/api/activityBaseApi";

export const activityPriorityApi = activityBaseApi.injectEndpoints({
  endpoints: (build) => ({
    getActivitiesPriority: build.query<any, number>({
      query: (cityId) => `manageActivity/fetchActivities/${cityId}`,
      providesTags: [ActivityTags.getPriority],
    }),
    updatePriority: build.mutation<any, any>({
      query: (body) => ({
        url: "manageActivity/updateActivityPriority",
        method: "POST",
        body,
      }),
      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        try {
          await queryFulfilled;
          dispatch(activityPriorityApi.util.resetApiState());
        } catch (err) {
          console.log(err);
        }
      },
      invalidatesTags: [ActivityTags.getPriority],
    }),
    getCities: build.query({
      query: () => `manageActivity/getAllCities`,
    }),
  }),
  overrideExisting: false,
});
